export interface EdiDelayReason {
  label: string;
  delayCode: EdiDelayReasonCode;
}

export enum EdiDelayReasonCode {
  A2 = 'A2',
  AD = 'AD',
  AG = 'AG',
  AH = 'AH',
  AJ = 'AJ',
  AM = 'AM',
  AN = 'AN',
  AO = 'AO',
  AQ = 'AQ',
  AS = 'AS',
  AX = 'AX',
  AY = 'AY',
  B1 = 'B1',
  B2 = 'B2',
  B5 = 'B5',
  B8 = 'B8',
  BB = 'BB',
  BD = 'BD',
  BF = 'BF',
  BH = 'BH',
  BM = 'BM',
  BP = 'BP',
  BQ = 'BQ',
  BS = 'BS',
  C5 = 'C5',
  D1 = 'D1',
  D2 = 'D2',
  HB = 'HB',
  NS = 'NS',
  P4 = 'P4',
  RC = 'RC',
  S1 = 'S1',
  T7 = 'T7'
}

export const delayReasonList: EdiDelayReason[] = [
  { label: 'A2 Incorrect Address', delayCode: EdiDelayReasonCode.A2 },
  { label: 'AD Customer Requested Future Delivery', delayCode: EdiDelayReasonCode.AD },
  { label: 'AG Consignee Related', delayCode: EdiDelayReasonCode.AG },
  { label: 'AH Driver Related', delayCode: EdiDelayReasonCode.AH },
  { label: 'AJ Other Carrier Related', delayCode: EdiDelayReasonCode.AJ },
  { label: 'AM Shipper Related', delayCode: EdiDelayReasonCode.AM },
  { label: 'AN Holiday - Closed', delayCode: EdiDelayReasonCode.AN },
  { label: 'AO Weather or Natural Disaster Related', delayCode: EdiDelayReasonCode.AO },
  { label: 'AQ Recipient Unavailable - Delivery Delayed', delayCode: EdiDelayReasonCode.AQ },
  { label: 'AS Hold Due to Customs Documentation Problems', delayCode: EdiDelayReasonCode.AS },
  { label: 'AX Insufficient Pick-up Time', delayCode: EdiDelayReasonCode.AX },
  { label: 'AY Missed Pick-up', delayCode: EdiDelayReasonCode.AY },
  { label: 'B1 Consignee Closed', delayCode: EdiDelayReasonCode.B1 },
  { label: 'B2 Trap for Customer', delayCode: EdiDelayReasonCode.B2 },
  { label: 'B5 Held for Consignee', delayCode: EdiDelayReasonCode.B5 },
  { label: 'B8 Improper Unloading Facility or Equipment', delayCode: EdiDelayReasonCode.B8 },
  { label: 'BB Held per Shipper', delayCode: EdiDelayReasonCode.BB },
  { label: 'BD Border Clearance', delayCode: EdiDelayReasonCode.BD },
  { label: 'BF Carrier Keying Error', delayCode: EdiDelayReasonCode.BF },
  { label: 'BH Insufficient Time to Complete Delivery', delayCode: EdiDelayReasonCode.BH },
  { label: 'BM Flatcar Shortage', delayCode: EdiDelayReasonCode.BM },
  { label: 'BP Load Shifted', delayCode: EdiDelayReasonCode.BP },
  { label: 'BQ Shipment Overweight', delayCode: EdiDelayReasonCode.BQ },
  { label: 'BS Refused by Customer', delayCode: EdiDelayReasonCode.BS },
  { label: 'C5 Customer Strike', delayCode: EdiDelayReasonCode.C5 },
  { label: 'D1 Carrier Dispatch Error', delayCode: EdiDelayReasonCode.D1 },
  { label: 'D2 Driver Not Available', delayCode: EdiDelayReasonCode.D2 },
  { label: 'HB Held Pending Appointment', delayCode: EdiDelayReasonCode.HB },
  { label: 'NS Normal Status', delayCode: EdiDelayReasonCode.NS },
  { label: 'P4 Held for Full Carrier Load', delayCode: EdiDelayReasonCode.P4 },
  { label: 'RC Reconsigned', delayCode: EdiDelayReasonCode.RC },
  { label: 'S1 Delivery Shortage', delayCode: EdiDelayReasonCode.S1 },
  { label: 'T7 Insufficient Delivery Time', delayCode: EdiDelayReasonCode.T7 }
];
